import { render, staticRenderFns } from "./PayStatement.vue?vue&type=template&id=19bcc9aa&scoped=true&"
import script from "./PayStatement.vue?vue&type=script&lang=js&"
export * from "./PayStatement.vue?vue&type=script&lang=js&"
import style0 from "./PayStatement.vue?vue&type=style&index=0&id=19bcc9aa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bcc9aa",
  null
  
)

export default component.exports